import { render, staticRenderFns } from "./CircleTag.vue?vue&type=template&id=6484761d&scoped=true"
import script from "./CircleTag.vue?vue&type=script&lang=js"
export * from "./CircleTag.vue?vue&type=script&lang=js"
import style0 from "./CircleTag.vue?vue&type=style&index=0&id=6484761d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484761d",
  null
  
)

export default component.exports